import { forwardRef } from 'react';
import cn from 'classnames';
import s from 'styled-components';

const SwitcherContainer = s.div`
position: relative;
width: 40px;
height: 24px;
padding: 3px;
background-color: ${({ theme }) => theme.colors.blackt20};
border-radius: 40px;
cursor: pointer;
transition: background-color 0.3s ease-in-out;

&.--hovered,
&:hover {
  background-color: ${({ theme }) => theme.colors.blackt40};
}

&.--disabled {
  background-color: ${({ theme }) => theme.colors.grey200} !important;
  pointer-events: none;
}

&.--on {
  background-color: ${({ theme }) => theme.colors.red};

  &.--hovered,
  &:hover {
    background-color: ${({ theme }) => theme.colors.red80};
  }

  &.--disabled {
    background-color: ${({ theme }) => theme.colors.red40} !important;
  }
}

&.--on .w-switcher-toggle {
  left: 100%;
  color: ${({ theme }) => theme.colors.white};
  transform: translateX(-100%);
}

.w-switcher {
  &-inner {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  &-toggle {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 100%;
    color: ${({ theme }) => theme.colors.white};
    font-weight: 600;
    font-size: 12px;
    text-transform: capitalize;
    background-color: #fff;
    border-radius: 18px;
    transition: transform 0.3s ease-in-out, left 0.3s ease-in-out;
  }
}

.fake-input {
  position: absolute;
  left: -9999px;
  visibility: hidden;
}
`;

const Switcher = forwardRef(
  (
    {
      onLabel = '',
      offLabel = '',
      className = '',
      value = false,
      isDisabled = false,
      readOnly = false,
      isHovered = false,
      clickOff,
      ...attr
    },
    ref,
  ) => {
    const handleClick = (e) => {
      if (isDisabled || clickOff) {
        e.preventDefault();
      }

      if (!clickOff) {
        e.stopPropagation();
      }
    };

    return (
      <SwitcherContainer
        ref={ref}
        className={cn('w-switcher', {
          '--on': value,
          '--disabled': isDisabled,
          '--hovered': isHovered,
        }, className)}
        type="button"
        onClick={handleClick}
      >
        <label className="w-switcher-inner">
          <input
            {...attr}
            className="fake-input"
            disabled={isDisabled}
            readOnly={readOnly || isDisabled}
            type="checkbox"
            value={value}
          />
          <div className="w-switcher-toggle">
            {onLabel || offLabel ? (
              <span className="w-switcher-label">
                {value ? onLabel : offLabel}
              </span>
            ) : (
              ''
            )}
          </div>
        </label>
      </SwitcherContainer>
    );
  },
);

Switcher.displayName = 'Switcher';

export default Switcher;
